'use client';
import Image from 'next/image';
import DOMPurify from 'isomorphic-dompurify';
import { enCodeLink, formatDate } from '@/utils';
// import { Paper } from '@mui/material';
// import { Button } from '@mui/material';
import Link from 'next/link';
// import { convert } from 'html-to-text';

export default function RelatedCards({ data }: any) {
    if (!data) return <h1>Something went wrong...</h1>;
    const { para = '', date = '', headLine = '', mediaLink = '', editorialId: id } = data || {};
    // const text = convert(decodeURI(headLine), {});
    // console.log(data.editorialType.type);
    return (
        <>
            <div className="flex flex-wrap justify-center py-3">
                <div className="rounded-lg overflow-hidden lg:w-full w-[100%] transition-transform transform hover:-translate-y-2 ">
                    <Link href={`${enCodeLink(headLine, id)}`}>
                        <Image
                            src={mediaLink}
                            width={1000}
                            height={1000}
                            alt="Update Image"
                            className="w-full h-auto object-cover rounded-2xl"
                        />
                    </Link>
                    <div className="mt-4 p-2 border-t-[1px] border-solid border-[#0B3619]">
                        <div className="flex justify-between items-center mb-2 lg:mb-4">
                            <p
                                className="tracking-wide uppercase"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 500,
                                    fontSize: '14.4px',
                                    textAlign: 'start',
                                    color: '#0B3619',
                                }}
                            >
                                {data.editorialType.type}
                            </p>
                            <p
                                className="tracking-wide uppercase"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 500,
                                    fontSize: '14.4px',
                                    textAlign: 'start',
                                    color: '#0B3619',
                                }}
                            >
                                {formatDate(date)}
                            </p>
                        </div>
                        <Link href={`${enCodeLink(headLine, id)}`}>
                            <p
                                className="line-clamp-2 mb-2"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '21.19px',
                                    color: '#000000',
                                    lineHeight: '26.49px',
                                    initialLetter: '-0.85px',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(headLine),
                                }}
                            />
                        </Link>
                        <div
                            className="line-clamp-3"
                            style={{
                                fontFamily: 'Inter',
                                fontWeight: 300,
                                fontSize: '15.3px',
                                color: '#435166',
                                lineHeight: '22.96px',
                                letterSpacing: '-0.31px',
                            }}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(para) }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
